const createdClassrooms = state => state.createdClassrooms;
const userClassrooms = state => state.userClassrooms;

export {
  createdClassrooms,
  userClassrooms,
}